import { request } from '@/shared/api/request'

export const getDicResultTypes = () => {
	return request({ url: `/selftest/auth/get/resultTypes`, method: 'GET' })
}
